import { render } from "./reduction.vue?vue&type=template&id=07626ae6&scoped=true"
import script from "./reduction.vue?vue&type=script&lang=js"
export * from "./reduction.vue?vue&type=script&lang=js"

import "./reduction.vue?vue&type=style&index=0&id=07626ae6&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07626ae6"]])

export default __exports__